import { useRouter } from 'next/router'
import { Modal, Button } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import { deleteAccount, logout } from '@/features/auth/apis/authSlice'
import { errorHandling, openNotification } from '@/utils/utils'

import Close from '@/components/svgs/CloseModal'

const DeleteAccount = ({ open, setOpen }) => {
  const { t } = useTranslation()
  const { push } = useRouter()
  const dispatch = useDispatch()

  const { deleteAccountLoading } = useSelector((state) => state.auth)

  // SUBMITING FORM
  const handleSubmit = () => {
    dispatch(deleteAccount())
      .unwrap()
      .then(() => {
        dispatch(logout())
        push('/')
        setOpen(false)
      })
      .catch((error) => openNotification('error', errorHandling(error)))
  }

  return (
    <Modal
      className='!w-[40rem]'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
    >
      <div className='text-center mb-28 mt-16'>
        <h3 className='text-xl font-semibold capitalize mb-8 w-11/12 mx-auto'>
          {t('confirm.account-delete.title')}
        </h3>
        <p className='text-dimmed leading-6 text-sm w-9/12 mx-auto'>
          {t('confirm.account-delete.description')}
        </p>
      </div>

      <Button
        className='block btn-danger text-base font-semibold tracking-wide rounded-lg py-12 h-auto mt-32 mb-20 w-7/12 mx-auto'
        loading={deleteAccountLoading}
        onClick={handleSubmit}
      >
        {t('Permanently Delete Account')}
      </Button>

      <Close
        style='absolute top-28 right-36 cursor-pointer'
        onClick={() => setOpen(false)}
      />
    </Modal>
  )
}

export default DeleteAccount
